import React, {useState} from "react";
import {Col, Modal, Row, Space} from "antd";
import {useTranslate} from "../../../../../../hooks/translate.hook";
import Dragger from "antd/es/upload/Dragger";
import {orderDataService} from "../../../../../../services/orders/order-data/order.data.service";

interface OrderDataHeaderUploadPricesModalProps {
    orderId: number;
    onClose: () => void
    onComplete: () => void
}

export const OrderDataHeaderUploadPricesModal: React.FC<OrderDataHeaderUploadPricesModalProps> = ({orderId, onClose, onComplete}) => {
    const t = useTranslate();

    const [loading, setLoading] = useState(false);

    return (
        <Modal
            open
            confirmLoading={loading}
            title={t("Upload prices")}
            cancelText={t("CANCEL")}
            centered
            onCancel={() => {
                onClose();
            }}
            onOk={() => {
                onClose();
            }}
        >
            <Space>
                <Row gutter={10}>
                    <Col span={24}>
                        <Dragger
                            accept={".csv"}
                            showUploadList={false}
                            customRequest={async (data) => {
                                setLoading(true);
                                try {
                                    await orderDataService.updatePricesFromCSVFile(orderId, data.file as File)
                                    onClose();
                                    onComplete();
                                } finally {
                                    setLoading(false);
                                }
                            }}
                        >
                            <p className="ant-upload-text" style={{textAlign: "left", paddingLeft: 20}}>{t('CLAIMS.CREATE.UPLOAD.P1')}</p>
                            <p className="ant-upload-hint" style={{textAlign: "left", paddingLeft: 20}}>
                                Please upload a csv file with two columns: article name and price
                            </p>
                        </Dragger>
                    </Col>
                </Row>
            </Space>
        </Modal>
    );
};
